import React, { useState } from "react";
import AuthShell from "@/components/AuthShell";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [resetToken, setResetToken] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setMessage(""); setResetToken("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMessage(data.message || "If an account exists, a reset link has been sent.");
      if (data.reset_token) setResetToken(data.reset_token);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Reset your password"
      subtitle="Enter your email and we'll generate a reset token."
      footer={
        <Link to="/signin" className="text-neu-accent font-semibold" data-testid="forgot-back">
          Back to sign in
        </Link>
      }
    >
      <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
        <div>
          <label className="text-sm font-medium block mb-2">Email</label>
          <input
            required
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="neu-input"
            data-testid="forgot-email"
          />
        </div>
        {error && <div className="text-sm text-red-600 bg-red-50 p-3 rounded-xl">{error}</div>}
        {message && (
          <div className="text-sm text-neu-accent bg-neu-accent/10 p-3 rounded-xl" data-testid="forgot-message">
            {message}
          </div>
        )}
        {resetToken && (
          <div className="text-xs subtle bg-neu-bg p-3 rounded-xl break-all" data-testid="forgot-token">
            Dev-only reset token: <span className="font-mono">{resetToken}</span>
            <div className="mt-2">
              <Link
                to={`/reset-password?token=${encodeURIComponent(resetToken)}`}
                className="text-neu-accent font-semibold"
              >
                Continue to reset →
              </Link>
            </div>
          </div>
        )}
        <button type="submit" disabled={loading} className="btn-accent w-full" data-testid="forgot-submit">
          {loading ? "Sending…" : "Send reset link"}
        </button>
      </form>
    </AuthShell>
  );
}
